document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-fwc').forEach(function (section) {
    var tabs = section.querySelectorAll('.custom-fwc__tab');
    var panels = section.querySelectorAll('.custom-fwc__panel');

    function scrollAmount(track) {
      var firstCard = track.firstElementChild;
      if (!firstCard) return 260;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || 20, 10);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateNavButtons(panel) {
      var track = panel.querySelector('[data-fwc-track]');
      var prevBtn = panel.querySelector('[data-fwc-prev]');
      var nextBtn = panel.querySelector('[data-fwc-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    panels.forEach(function (panel) {
      var track = panel.querySelector('[data-fwc-track]');
      var prevBtn = panel.querySelector('[data-fwc-prev]');
      var nextBtn = panel.querySelector('[data-fwc-next]');
      if (!track) return;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(track), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(track), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', function () {
        updateNavButtons(panel);
      });
      window.addEventListener('resize', function () {
        updateNavButtons(panel);
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-fwc-target');
        var targetPanel = document.getElementById(targetId);
        if (!targetPanel) return;

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        targetPanel.classList.add('is-active');
        updateNavButtons(targetPanel);
      });
    });

    panels.forEach(function (panel) {
      if (panel.classList.contains('is-active')) {
        updateNavButtons(panel);
      }
    });
  });
});